// @ts-nocheck
import { Link as RouterLink, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// material
import {
  Grid,
  Button,
  Container,
  Stack,
  Typography,
  Rating,
  Image,
  Avatar,
  TextField,
  Paper,
  Fab,
} from '@mui/material';
// components
import Page from '../../components/Page';
import { useDispatch, useSelector } from 'react-redux';
import { red, grey, green } from '@mui/material/colors';
import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import { setBookings, getbookingSpaces, reset } from '../../store/state/bookingSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useGetAllBookingDetailBySearchCriteriaMutation } from '../../store/api/bookingsApi';
import { format } from 'date-fns';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: grey[400],
  ...theme.typography.body2,
  padding: '25px',
  height: '100%',
  textAlign: 'center',
}));

// ----------------------------------------------------------------------

export default function VendorParkingSpots() {
  const params = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(params.search);
  const parkingSpaceId = parseInt(searchParams.get('id'));
  const parkingSpace = useSelector((state: any) =>
    state.parkings?.data?.find((parking: any) => parking.id === parkingSpaceId)
  );
  const [getAllBookingDetailBySearchCriteria, getAllResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const token = JSON.parse(localStorage.getItem('login')).token || null;
  const [value, setValue] = useState(0);
  const parkingSpotsData = useAppSelector(getbookingSpaces);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const dispatch = useAppDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    let flag = '';
    switch (newValue) {
      case 0:
        flag = 'BOOKING_REPORT_TYPE_00_TO_6';
        break;
      case 1:
        flag = 'BOOKING_REPORT_TYPE_6_TO_12';
        break;
      case 2:
        flag = 'BOOKING_REPORT_TYPE_12_TO_18';
        break;
      case 3:
        flag = 'BOOKING_REPORT_TYPE_18_TO_00';
        break;
    }
    getAllBookingDetailBySearchCriteria({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        columnName: '',
        orderBy: '',
        parkingLocationId: parkingSpaceId,
        flag: flag,
      },
    });
  };

  useEffect(() => {
    getAllBookingDetailBySearchCriteria({
      token: token,
      payload: {
        offset: rowsPerPage,
        page: page,
        columnName: '',
        orderBy: '',
        parkingLocationId: parkingSpaceId,
        flag: 'BOOKING_REPORT_TYPE_00_TO_6',
      },
    });
  }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setBookings(getAllResponse.data));
    }
  }, [getAllResponse.isSuccess]);

  return (
    <Page title="Parking Space">
      <Box sx={{ boxShadow: '0px 0px 12px #0000002f', padding: '30px', borderRadius: '10px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" component="div" gutterBottom>
            {parkingSpace?.parking_space_name}
          </Typography>
          <Stack direction="row" alignItems="center">
            <Stack direction="row" alignItems="center" marginRight="20px">
              <Box style={{ borderRadius: '100px', background: green[500], height: '20px', width: '20px' }}></Box>
              <Typography variant="subtitle1" component="div" marginLeft={'10px'}>
                Booked
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center">
              <Box style={{ borderRadius: '100px', background: grey[400], height: '20px', width: '20px' }}></Box>
              <Typography variant="subtitle1" component="div" marginLeft={'10px'}>
                Upcoming
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="row" alignItems="start" justifyContent="flex-start" mb={5}>
          <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
            <LinkTab label="00:00 - 06:00" />
            <LinkTab label="06:00 - 12:00" />
            <LinkTab label="12:00 - 18:00" />
            <LinkTab label="18:00 - 00:00" />
          </Tabs>
        </Stack>
        <Grid container spacing={2}>
          {parkingSpotsData && parkingSpotsData.length > 0 ? (
            parkingSpotsData.map((parkingSpot, index) => (
              <Grid item lg={3} md={4} sm={6} xs={12} key={index.toString()}>
                <Item style={{ background: new Date(parkingSpot.checkinTime) > new Date() ? grey[400] : green[500] }}>
                  <Typography variant="h5" gutterBottom>
                    {parkingSpot.parkingSlotRespDTO.slotId}
                  </Typography>
                  <Typography variant="h5" gutterBottom>
                    {format(new Date(parkingSpot.checkinTime), 'hh:mm a')}
                    {' - '}
                    {format(new Date(parkingSpot.checkinTime), 'hh:mm a')}
                  </Typography>
                  <Typography>{parkingSpot.customerDetailResponseDTO.name}</Typography>
                  <Typography>Reg No. {parkingSpot.uniqueBookingId}</Typography>
                </Item>
              </Grid>
            ))
          ) : (
            <Box sx={{ padding: '30px', borderRadius: '10px' }}>
              <Typography variant="h4" component="div" gutterBottom>
                No bookings available...
              </Typography>
            </Box>
          )}
        </Grid>
        <Box sx={{ position: 'fixed', bottom: 20, right: 20 }}>
          <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-start' }}>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                navigate('/dashboard/all-parking-spaces', { replace: true });
              }}
              sx={{ marginRight: '10px' }}
              size="large"
            >
              Back
            </Button>
          </div>
        </Box>
        <Box sx={{ position: 'fixed', bottom: 20, left: 20 }}>
          <Fab color="secondary" aria-label="add">
            <AddIcon />
          </Fab>
        </Box>
      </Box>
    </Page>
  );
}
